export enum EFdrProductType {
  AdventureTravel = 'ADVENTURE_TRAVEL',
  RoundTrip = 'ROUND_TRIP',
  Hotel = 'HOTEL',
}
